import React from "react";

interface IPercentFormatterProps {
  digits?: number;
  locale?: string;
  value?: number;
}

export const percentFormatter = ({ value, locale, digits }: IPercentFormatterProps) => {
  const formatter = new Intl.NumberFormat(locale || "default", {
    maximumSignificantDigits: digits,
    style: 'percent',
  });
  return formatter.format(value || 0)
}

const PercentTag = (props: IPercentFormatterProps): React.ReactNode => {
  const formattedValue = percentFormatter(props);
  return <>{formattedValue}</>;
};


export default PercentTag;
